let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("b8BDn")).then(() => parcelRequire('6fuwe'));